export default __webpack_public_path__ + "static/media/kumato-roasted-kumato.5b2c7a79.jpg";